const initialState = {
    message: '',
    level: 'success',
    icon: '',
    id: '1',
};

export default initialState;
